<template>
  <v-col cols="12">
    <v-row class="align-stretch" justify="start" align-content="start">
      <v-col cols="12" sm="6">
        <SingleValueChart
            :title="$t('components.AppointmentsDashboard.TotalAppointmentsLabel')"
            :data="stats.total_appointments"
            :loading="loading" :report-mode="reportMode"/>
      </v-col>
      <v-col cols="12" sm="6">
        <SingleValueChart
            :title="$t('components.AppointmentsDashboard.BookedAppointmentsLabel')"
            :data="stats.booked_appointments"
            :loading="loading" :report-mode="reportMode"/>
      </v-col>
    </v-row>
    <v-row class="align-stretch" justify="start" align-content="start">
      <v-col cols="12" sm="6" md="4">
        <SingleValueChart
            :title="$t('components.AppointmentsDashboard.ShowedAppointmentsLabel')"
            :data="stats.showed_appointments"
            :loading="loading" :report-mode="reportMode"/>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <SingleValueChart
            :title="$t('components.AppointmentsDashboard.NoShowedAppointmentsLabel')"
            :data="stats.noshow_appointments"
            :loading="loading" :report-mode="reportMode"/>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <SingleValueChart
            :title="$t('components.AppointmentsDashboard.CancelledAppointmentsLabel')"
            :data="stats.cancelled_appointments"
            :loading="loading" :report-mode="reportMode"/>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import SingleValueChart from '@/components/dashboard/charts/SingleValueChart';


export default {
  name: 'AppointmentsWidgets',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    reportMode: {
      type: String,
      required: false,
      default: null
    },
    data: {
      type: Object,
      default: () => ({
        total_appointments: 0,
        booked_appointments: 0,
        showed_appointments: 0,
        noshow_appointments: 0,
        cancelled_appointments: 0,
      })
    }
  },
  data: () => ({
    stats: {
      total_appointments: 0,
      booked_appointments: 0,
      showed_appointments: 0,
      noshow_appointments: 0,
      cancelled_appointments: 0,
    }
  }),
  methods: {
    updateStats(data) {
      if (data) {
        this.stats = data;
      }
    },
  },
  watch: {
    data(value) {
      this.updateStats(value);
    }
  },
  components: {SingleValueChart}
}
</script>